// src/logic/joinLogic.js
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { requestNotificationPermission, getFCMToken, saveFCMToken } from '../utils/notificationManager';
import { validatePassword, shouldEnforcePasswordPolicy } from '../utils/passwordPolicy';

export const registerUser = async (email, password, pseudo, facebookLink) => {
    try {
        // 🔐 Enforce password policy for new users
        const shouldEnforce = shouldEnforcePasswordPolicy(true, false);
        if (shouldEnforce) {
            const validation = validatePassword(password, email, pseudo);
            if (!validation.isValid) {
                return { 
                    success: false, 
                    message: 'Password does not meet security requirements',
                    validation: validation
                };
            }
        }

        // 1️⃣ Create Auth user
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const firebaseUser = userCredential.user;

        // 2️⃣ Save user profile in Firestore
        await setDoc(doc(db, "users", firebaseUser.uid), {
            pseudo,
            email,
            facebookLink,
            dp: 0,
            createdAt: serverTimestamp()
        });

        // 🔔 Setup notifications for new user
        const hasPermission = await requestNotificationPermission();
        if (hasPermission) {
            const fcmToken = await getFCMToken();
            if (fcmToken) {
                await saveFCMToken(firebaseUser.uid, fcmToken);
            }
        }

        // 3️⃣ Store local session
        const session = {
            uid: firebaseUser.uid,
            email,
            pseudo
        };
        localStorage.setItem('userSession', JSON.stringify(session));

        return { success: true, session };
    } catch (error) {
        console.error("Register error:", error);
        return { success: false, message: error.message };
    }
};


